export const responseType = {
	success: 0,
	unregisteredAccount: 1,
	reqeustChangeInitialPassword: 2,
	reregistrationStep1Success: 3,
	notExistSessionInfo: 50,
	notExistApiResponseData: 51,
	loginLockError: 80,
	apiError: 90,
	dbError: 91,
	limitOverError: 92,
	WebStorageError: 94,
	timeoutError: 95,
	unauthorizedError: 96,
	validationError: 97,
	systemError: 99,
} as const;
